export default __webpack_public_path__ + "static/media/arrow_Up.a39e24e3.svg";